import { combineReducers } from 'redux';
import { History } from 'history';
import { RouterState, connectRouter } from 'connected-react-router'
import generalReducer from './general';
import { General } from '../states/general';

const rootReducer = (history: History) => combineReducers({
  general: generalReducer,
  router: connectRouter(history),
})

export interface State {
  general: General,
  router: RouterState,
}

export default rootReducer;
